module.exports = __webpack_public_path__ + "img/gyant_light_ba_list.d1786258.jpg";